<template>
    <v-snackbar
            :timeout="state.timeout"
            color="primary"
            v-model="show"
    >
        {{ state.message }}
        <v-btn
                @click="close"
                color="white"
                text
        >
            Close
        </v-btn>
    </v-snackbar>
</template>

<script>
    import SnackbarStore from "@/ts/stores/SnackbarStore";

    export default {
        name: "Snackbar",

        data() {
            return {
                state: SnackbarStore.state,
                show: false
            }
        },
        watch: {
            state: {
                handler() {
                    this.show = this.state.snackbarVisible;
                },
                deep: true
            },
            show(val) {
                if (!val) {
                    this.close()
                }
            }
        },
        methods: {
            close() {
                SnackbarStore.dismiss()
            }
        }
    }
</script>

<style scoped>

</style>